import { Button, Flex, Select, Space, Stack, Text } from "@mantine/core";
import React, { useState } from "react";
import { useApplication } from "../../Application";
import { type Charity } from "./Charity";
import { munColors } from "../../Misc/munColors";

type ChooseProps = {
  closeModal: () => void;
  chooseCharity: (chosen: Charity) => void;
  availableCharities: Charity[];
};

export const Choose: React.FC<ChooseProps> = ({
  closeModal,
  chooseCharity,
  availableCharities,
}) => {
  const { t } = useApplication();
  const [charity, setCharity] = useState(availableCharities[0]);



  return (
    <Stack>
      <Text>
        {t('modals.collectReward.choose_description')}
      </Text>

      <Space h="md"/>

      <Select
        label={t('modals.collectReward.select_charity')}
        data={availableCharities.map(c => ({ label: c.name, value: c.address }))}
        value={charity.address}
        onChange={(value) => setCharity(availableCharities.find(c => c.address === value)!)}
      />

      <Space h="md"/>

      <Flex gap="5" justify="space-between">
        <Button color="red" variant="subtle" onClick={closeModal}>
          <Text>{t('modals.cancel')}</Text>
        </Button>
        <Button
          gradient={munColors.greenGradient}
          variant="gradient"
          onClick={() => chooseCharity(charity)}
        >
          <Text>{t('modals.collectReward.confirm')}</Text>
        </Button>
      </Flex>
    </Stack>
  );
};
